(() => {
  const connected = new WeakSet();
  const scope = (info) => info.closest('.fv-pdp-final') || info;
  const owner = (element) => {
    const info = element.closest('product-info[data-fv-require-size]');
    if (info) return info;
    const sticky = element.closest('sticky-atc[data-sticky-section-id]');
    return sticky ? document.getElementById(`MainProduct-${sticky.dataset.stickySectionId}`) : null;
  };
  const refresh = (info) => {
    if (!info || info.dataset.fvRequireSize !== 'true') return;
    const root = scope(info);
    const groups = root.querySelectorAll('[data-fv-size-option]');
    if (!groups.length) info.dataset.fvSizePending = 'false';
    const pending = info.dataset.fvSizePending === 'true';
    delete info.dataset.fvSelectionLoading;
    root.dataset.fvSizePending = String(pending);
    root.dataset.fvSelectionLoading = 'false';
    if (pending) {
      groups.forEach((group) => {
        group.querySelectorAll('input[type="radio"]').forEach((input) => {
          input.checked = false;
          input.classList.remove('checked');
          input.nextElementSibling?.classList.remove('checked');
        });
        const selectedLabel = group.querySelector('[data-selected-value]');
        if (selectedLabel) selectedLabel.textContent = '';
      });
      info.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]').forEach((input) => { input.value = ''; });
    }
    const mainPicker = info.querySelector('variant-selects[data-context="main"]');
    const stickyPicker = root.querySelector('variant-selects[data-context="sticky"]');
    mainPicker?.querySelectorAll('input[type="radio"]').forEach((input) => {
      const target = [...(stickyPicker?.querySelectorAll('input[type="radio"]') || [])].find((item) => item.dataset.optionValueId && item.dataset.optionValueId === input.dataset.optionValueId);
      if (target) target.checked = input.checked;
    });
    root.querySelectorAll('.shopify-payment-button').forEach((button) => {
      button.toggleAttribute('inert', pending);
    });
    if (!pending) root.querySelectorAll('[data-fv-variant-error]').forEach((error) => { error.hidden = true; });
  };
  const connect = (info) => {
    if (connected.has(info) || info.dataset.fvRequireSize !== 'true') return;
    connected.add(info);
    refresh(info);
  };
  const askForSize = (info) => {
    const root = scope(info);
    const error = root.querySelector('[data-fv-size-error]');
    if (error) error.hidden = false;
    const group = info.querySelector('[data-fv-size-option]');
    group?.scrollIntoView({ block: 'center', behavior: 'smooth' });
    const input = group?.querySelector('input:not(:disabled):not(.disabled)');
    input?.focus({ preventScroll: true });
  };
  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element)) return;
    const picker = event.target.closest('variant-selects');
    if (!picker) return;
    const info = owner(picker);
    if (!info || info.dataset.fvRequireSize !== 'true') return;
    if (event.target.closest('[data-fv-size-option]') && event.target.checked && !event.target.disabled && !event.target.classList.contains('disabled')) {
      info.dataset.fvSizePending = 'false';
      scope(info).querySelectorAll('[data-fv-size-error]').forEach((error) => { error.hidden = true; });
    }
    info.dataset.fvSelectionLoading = 'true';
    scope(info).dataset.fvSelectionLoading = 'true';
    scope(info).querySelectorAll('.shopify-payment-button').forEach((button) => button.setAttribute('inert', ''));
  }, true);
  document.addEventListener('submit', (event) => {
    if (!(event.target instanceof Element)) return;
    const info = owner(event.target);
    if (!info || info.dataset.fvRequireSize !== 'true' || !event.target.matches('form[data-type="add-to-cart-form"]')) return;
    if (info.dataset.fvSizePending === 'true' || info.dataset.fvSelectionLoading === 'true') {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (info.dataset.fvSizePending === 'true') askForSize(info);
    }
  }, true);
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a[data-fv-size-link]');
    if (!link || !owner(link)) return;
    const selector = link.closest('side-drawer-opener')?.dataset.sideDrawer;
    const drawer = selector ? document.querySelector(selector) : null;
    if (typeof drawer?.open === 'function') {
      event.preventDefault();
      drawer.open(link);
    }
  });
  const fail = (info) => {
    if (info.dataset.fvRequireSize !== 'true') return;
    info.dataset.fvSizePending = 'true';
    refresh(info);
    info.dataset.fvSelectionLoading = 'true';
    scope(info).dataset.fvSelectionLoading = 'true';
    scope(info).querySelectorAll('.shopify-payment-button').forEach((button) => button.setAttribute('inert', ''));
    const error = scope(info).querySelector('[data-fv-variant-error]');
    if (error) error.hidden = false;
  };
  window.FVPDPSizeGuard = { connect, refresh, fail };
  const scan = (root) => root.querySelectorAll('product-info[data-fv-require-size]').forEach(connect);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), { once: true });
  else scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
